import { render } from "./Standards.vue?vue&type=template&id=394eadf6&scoped=true"
import script from "./Standards.vue?vue&type=script&lang=js"
export * from "./Standards.vue?vue&type=script&lang=js"

import "./Standards.vue?vue&type=style&index=0&id=394eadf6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394eadf6"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QBtn,QMenu,QBanner});
